import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { clearAllStorage, getSessionCryptofacil, getUserCryptofacil } from "../services/utils/StorageUtils";

export const useRedirectWithoutSession = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const sessionCryptofacil = getSessionCryptofacil();
        const userCryptofacil = getUserCryptofacil();

        if (!sessionCryptofacil || !userCryptofacil) {
            clearAllStorage();
            navigate("/");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
